import { Box } from '@mui/material';
import { Heading } from 'components/CommonComponents';
import {Grid} from 'components/Grid';
import {PAD_MEDIUM, PAD_SMALL} from 'providers/designSystem';
import { CopyableColourSwatch } from 'components/ColourSwatch/CopyableColourSwatch';
import {ExportColourPaletteColoursButton} from "./ExportColourPaletteColours";

export const ColourPalette = ({ colourPalette }) => {
    return (
        <Grid numberOfColumns={1}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: `${PAD_SMALL}`,
                alignItems: 'center'
            }}>
                <Heading>{colourPalette.name}</Heading>
                <ExportColourPaletteColoursButton colourPalette={colourPalette} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '1rem',
                    paddingX: `${PAD_MEDIUM}`,
                    paddingY: `${PAD_MEDIUM}`,
                }}
            >
                {colourPalette.colours.map((colour, index) => {
                    return <CopyableColourSwatch key={colour.id} id={colour.id} size={'lg'} colour={colour} />;
                })}
            </Box>
        </Grid>
    );
};
